<template>
  <div>
    <el-dialog :visible.sync="dialogTagVisible" top="2%">
      <span slot="title">{{ tagTitle }}</span>
      <div ref="scrollDialogTagRef" class="dialog-tag-box">
        <div v-for="(v, i) in tagItem" :key="i" class="dialog-tag-item">
          <div class="dialog-tag-item-title">
            {{ v.label }}
          </div>
          <div class="dialog-tag-item-value">
            <span>{{ v.value }}</span>
            <span
              v-if="v.isEffective !== 0"
              :class="[
                'dialog-tag-item-value-status',
                { red: v.isEffective === 2 },
              ]"
              >{{ v.isEffective === 1 ? "有效" : "无效" }}</span
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Identification",
  components: {},
  props: {},
  data() {
    return {
      tagTitle: "",
      tagItem: [],
      dialogTagVisible: false,
    };
  },
  created() {},
  methods: {
    async show(value) {
      this.tagTitle = value.tagText;
      this.tagItem = value.items;
      this.dialogTagVisible = true;
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
</style>
<style lang="scss" scoped>
@import "./identification.scss";
</style>
